import React from 'react'
import Create from '../crud/create'
import fields from './fields'

const CreatePost = (props) => (
  <Create
// @ts-ignore
    title='Create Post'
    fields={fields}
    apiPath='admin/posts'
    successRedirectPath={resource => `/cms/posts/${resource.id}/edit`}
  />
)

export default CreatePost
